export const DEMO_LOGIN_ENABLED = process.env.REACT_APP_DEMO_LOGIN === 'true';
